import { CheckList } from './CheckList';

import type { CutoverRequestResult } from './useCutover';

// The service's answer to a request it refused, or a request that failed,
// shown as the service wrote it
export function RequestError({
  result,
  error,
}: {
  result: CutoverRequestResult | undefined;
  error: Error | null;
}) {
  const refusal = result && !result.accepted ? result : undefined;
  if (!refusal && !error) return null;
  return (
    <div
      role="alert"
      className="space-y-3 rounded-md border border-destructive px-4 py-3 text-sm"
    >
      <p className="font-medium text-destructive">
        {refusal
          ? 'The cutover service refused this request.'
          : 'The request failed.'}
      </p>
      <p>{refusal?.action.outcome ?? error?.message}</p>
      {refusal && refusal.checks.some((check) => !check.passed) && (
        <CheckList
          checks={refusal.checks.filter((check) => !check.passed)}
          emptyText=""
        />
      )}
    </div>
  );
}
